import {createSlice} from "@reduxjs/toolkit";
import {
    getLocationCountrySales,
    getLocationInfluencerSales,
    getLocationSocialSales,
    getLocationStats
} from "./localizations.thunk";
import { resetAnalyticsOnSectionChange } from "../appNavigation.actions.js";

const initialState = {
    localizationsStatsData: {
        salesPerCountry: [],
        salesPerContinent: {},
        salesPerCountryPerContinent: [],
        influencersSalesPerCountry: [],
        smSalesPerCountry: [],
        charts: {
            continents: {
                unit: '',
                labels: [],
                datasets: [],
            }
        }
    },
    countrySalesTotalRows: 0,
    influencerSalesTotalRows: 0,
    socialSalesTotalRows: 0,
    getLocationStatsStatus: 'idle', //'idle' | 'loading' | 'succeeded' | 'failed',
    getLocationCountrySalesStatus: 'idle',
    getLocationInfluencerSalesStatus: 'idle',
    getLocationSocialSalesStatus: 'idle',
    errors: {}
};

export const localizationsSlice = createSlice({
    name: "localizations",
    initialState,
    reducers: {
        getSalesPerCountryPerContinent: (state, action) => {
            let id = action.payload;
            const filtered = state.localizationsStatsData.salesPerCountry.filter(item => item.continent === id);
            state.localizationsStatsData = {
                ...state.localizationsStatsData,
                salesPerCountryPerContinent: filtered
            };
            state.countrySalesTotalRows = filtered.length;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getLocationStats.pending, (state, action) => {
                state.getLocationStatsStatus = 'loading';
            })
            .addCase(getLocationStats.fulfilled, (state, action) => {
                delete state.errors.locationStats; //find error in Errors and delete it
                state.localizationsStatsData = {...state.localizationsStatsData, ...action.payload};
                state.getLocationStatsStatus = 'succeeded';
            })
            .addCase(getLocationStats.rejected, (state, action) => {
                state.errors = {...state.errors, locationStats: action.payload};
                state.getLocationStatsStatus = 'failed';
            })
            .addCase(getLocationCountrySales.pending, (state) => {
                state.getLocationCountrySalesStatus = 'loading';
            })
            .addCase(getLocationCountrySales.fulfilled, (state, action) => {
                delete state.errors.locationCountrySales;
                state.localizationsStatsData = {...state.localizationsStatsData, ...action.payload};
                state.countrySalesTotalRows = action.payload.countrySalesTotalRows ?? 0;
                state.getLocationCountrySalesStatus = 'succeeded';
            })
            .addCase(getLocationCountrySales.rejected, (state, action) => {
                state.errors = {...state.errors, locationCountrySales: action.payload};
                state.getLocationCountrySalesStatus = 'failed';
            })
            .addCase(getLocationInfluencerSales.pending, (state) => {
                state.getLocationInfluencerSalesStatus = 'loading';
            })
            .addCase(getLocationInfluencerSales.fulfilled, (state, action) => {
                delete state.errors.locationInfluencerSales;
                state.localizationsStatsData = {...state.localizationsStatsData, ...action.payload};
                state.influencerSalesTotalRows = action.payload.influencerSalesTotalRows ?? 0;
                state.getLocationInfluencerSalesStatus = 'succeeded';
            })
            .addCase(getLocationInfluencerSales.rejected, (state, action) => {
                state.errors = {...state.errors, locationInfluencerSales: action.payload};
                state.getLocationInfluencerSalesStatus = 'failed';
            })
            .addCase(getLocationSocialSales.pending, (state) => {
                state.getLocationSocialSalesStatus = 'loading';
            })
            .addCase(getLocationSocialSales.fulfilled, (state, action) => {
                delete state.errors.locationSocialSales;
                state.localizationsStatsData = {...state.localizationsStatsData, ...action.payload};
                state.socialSalesTotalRows = action.payload.socialSalesTotalRows ?? 0;
                state.getLocationSocialSalesStatus = 'succeeded';
            })
            .addCase(getLocationSocialSales.rejected, (state, action) => {
                state.errors = {...state.errors, locationSocialSales: action.payload};
                state.getLocationSocialSalesStatus = 'failed';
            })
            .addCase(resetAnalyticsOnSectionChange, () => JSON.parse(JSON.stringify(initialState)));
    }
});

export const selectLocalizationsStatsData = (state) => state.localizations.localizationsStatsData;

export const selectSalesPerCountryPerContinent = (state) => state.localizations.localizationsStatsData.salesPerCountryPerContinent;

export const selectLocationStatsStatus = (state) => state.localizations.getLocationStatsStatus;
export const selectLocationCountrySalesStatus = (state) => state.localizations.getLocationCountrySalesStatus;
export const selectLocationInfluencerSalesStatus = (state) => state.localizations.getLocationInfluencerSalesStatus;
export const selectLocationSocialSalesStatus = (state) => state.localizations.getLocationSocialSalesStatus;
export const selectLocationCountrySalesTotalRows = (state) => state.localizations.countrySalesTotalRows;
export const selectLocationInfluencerSalesTotalRows = (state) => state.localizations.influencerSalesTotalRows;
export const selectLocationSocialSalesTotalRows = (state) => state.localizations.socialSalesTotalRows;

export const selectLocalizationsErrorsStats = (state) => state.localizations.errors?.locationStats;

export const selectLocalizationsErrorsSales = (state) =>
    state.localizations.errors?.locationCountrySales ||
    state.localizations.errors?.locationInfluencerSales ||
    state.localizations.errors?.locationSocialSales;


export const {getSalesPerCountryPerContinent} = localizationsSlice.actions;


export default localizationsSlice.reducer;
